import React, { useEffect, useRef, useState } from 'react';
import { BrowserQRCodeReader } from '@zxing/browser';
import { Box, Button, Container, Stack } from "@mui/material";
import MODAL_TABLE from '../../../../main_components/modal/modal_Table';
import { bussines_partnert_put_qr, bussines_partnert_put } from '../../../../services/businesspartners/businesspartners';
import { supplier_get } from '../../../../services/expenses/expense';

import { BUSSINES_PARTNER } from '../interface/interface';
import { verifyToken } from '../../../../main_components/tokens/verifyToken';
import { updateSteps } from '../../../../components_cfdi/invoice/generate_invoice/constants/steps';
import ProcessPanel from '../../../../main_components/modal/process_panel';

interface CustomTableProps {
  data: any;
}

const CustomQRInvoiceImage: React.FC<CustomTableProps> = ({ data }) => {
  const [modalT, setModalT] = useState(false);
  const [messgeNotFound, setMessgeNotFound] = useState("");
  const [enableButton, setEnableButton] = useState(false);
  const [enableButtonNotFound, setEnableButtonNotFound] = useState(false);
  const [type_Suplier, setType_suplier] = useState(false);
  const [update_type, setupdate_type] = useState(false);
  const [dataResponse, setdataResponse] = useState<any>({});
  const [rfc, setrfc] = useState("");


  const [proc, setProc] = useState<{ open: boolean; title: string; progress: number }>({
    open: false,
    title: "Generando Factura",
    progress: 0,
  });

  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));


  const stepProcess = async (pct: number, delay = 500) => {
    setProc((s) => ({ ...s, progress: pct }));
    await sleep(delay);
  };

  const finishProcess = (delay = 300) =>
    setTimeout(() => setProc((s) => ({ ...s, open: false, progress: 0 })), delay);


  // ======= imagen =======
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);


  useEffect(() => {
    const t = setTimeout(() => fileInputRef.current?.click(), 0);
    return () => clearTimeout(t);
  }, []);

  // =================== LÓGICA DE NEGOCIO (copiada del de cámara) ===================
  const handle_response_url = async (url: string) => {
    setProc({ open: true, title: "Procesando código QR...", progress: 10 });
    setType_suplier(false);
    setupdate_type(false);

    try {
      const response = await bussines_partnert_put_qr({ url });
      console.log('Respuesta del servidor:', response);
      setMessgeNotFound("El socio de negocios fue actualizado correctamente en el sistema.");
      validar_rfc(url);
      await stepProcess(33);
      await stepProcess(66);
      await stepProcess(100);

    } catch (error: any) {
      console.log(error);
      if (error.status === 404 && error.response?.data) {
        const payload = error.response.data;
        console.log(payload)
        const bp = payload.business_partner || {};
        const addr = payload.address || {};

        await stepProcess(33);
        await stepProcess(66);
        await stepProcess(100);

        const filledObject = {
          code: "100",
          business_partner: bp.business_partner ?? null,
          rfc: bp.rfc ?? null,
          paymethod: "01",
          allow_invoicing: false,
          name: bp.name ?? null,
          force_code: false,
          first_last_name: bp.first_last_name ?? null,
          second_last_name: bp.second_last_name ?? null,
          capital_regime: bp.capital_regime ?? null,
          cfdi_use: "G03",
          tax_residence: null,
          num_reg_id_trib: null,
          metodo_pago: "PUE",
          tax_regime: bp.tax_regime ?? "616",
          email: bp.email ?? null,
          enable: true,
          person_type: (bp.rfc?.length === 12 ? "MORAL" : "FISICA"),
          zip_code: addr.zip_code ?? null,
          street: addr.street ?? null,
          city: addr.city ?? null,
          outdoor_number: addr.outdoor_number ?? null,
          inside_number: addr.inside_number ?? null,
          state: addr.state ?? "VERACRUZ DE IGNACIO DE LA LLAVE",
          reference: null,
          outer_code: null,
          account_number: null,
          id_accounting_account_fk: null,
          name_accounting_account: null,
          code_accounting_account: null,
          address_type: "FISCAL",
          country: "MÉXICO",
          town: null,
          subsidiary: "MATRIZ",
          neighborhood: addr.neighborhood ?? null,
          partner_type: "PROPIO",
          credit_days: null,
          business_partner_type: "CLIENTE",
        };

        setdataResponse(filledObject);
        setMessgeNotFound(payload.message);
        setEnableButtonNotFound(true);
        setEnableButton(false);
      }
    } finally {
      setEnableButton(true);
      finishProcess();
    }
  };

  const validar_rfc = (url: string) => {
    try {
      const params = new URL(url).searchParams;
      const d3 = params.get("D3");
      const r = d3?.split("_")[1];
      if (r) {
        setrfc(r);
        const data_bussiness_rfc = data.filter((item: any) => item.rfc === r);
        setType_suplier(data_bussiness_rfc.length === 0);
      } else {
        console.log("RFC inválido o no definido");
      }
    } catch {
      console.log("URL inválida");
    }
  };

  const handleBussinesPartner = async (event?: React.SyntheticEvent): Promise<void> => {
    event?.preventDefault();
    setProc({ open: true, title: "Actualizando...", progress: 10 });

    const isTokenValid = await verifyToken();
    if (!isTokenValid) {
      setTimeout(() => { handleBussinesPartner(); }, 1000);
      return;
    }
    try {
      const list = await fetchBussinesPartner();
      const data_supp = list.filter((item: any) => item.rfc === rfc);
      if (data_supp && data_supp.length) {
        await update_supplier(data_supp);
      }
      await stepProcess(33);
      await stepProcess(66);
      await stepProcess(100);
    } catch {
      console.log("Error al actualizar el tipo de socio");
    }
    finally {
      finishProcess();
    }
  };

  const update_supplier = async (data_supp: any) => {
    try {
      const supp = data_supp[0];
      const dat = {
        business_partner: {
          business_partner: supp.business_partner,
          rfc: supp.rfc,
          business_partner_type: "AMBOS",
          enable: supp.enable,
        },
        address: {},
      };
      await bussines_partnert_put(dat, supp.id);
      setModalT(false);
      setType_suplier(false);
      setupdate_type(true);
    } catch (err) {
      console.log(err);
      setModalT(false);
    }
  };

  const fetchBussinesPartner = async (): Promise<BUSSINES_PARTNER[]> => {
    try {
      const raw = await supplier_get();
      const payload = raw?.data;
      const list: BUSSINES_PARTNER[] = Array.isArray(payload) ? payload : payload?.business_partner ?? [];
      return list;
    } catch (error: any) {

      setModalT(false);
      alert(error?.response?.data?.errorMessage.es);
      return [];
    }
  };

  // 1) cerrar modal QR  2) abrir formulario de creación con la data del QR
  const handle_redirect_page = () => {
    window.dispatchEvent(new CustomEvent('bp:update-and-close', { detail: { refresh: false } }));
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('bp:open-create-from-qr', { detail: { data: dataResponse } }));
    }, 0);
  };



  // en imagen no hay cámara que apagar, pero mantenemos la misma API de botón
  const handle_update_and_close = () => {
    window.dispatchEvent(new CustomEvent('bp:update-and-close', { detail: { refresh: true } }));
  };

  // ======= lector desde imagen (ZXing) =======
  const onFileChange = async (ev: React.ChangeEvent<HTMLInputElement>) => {
    const file = ev.target.files?.[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    setImagePreview(imageUrl);

    const img = new Image();
    img.src = imageUrl;
    img.onload = async () => {
      try {
        const reader = new BrowserQRCodeReader();
        const res = await reader.decodeFromImageElement(img);
        if (res) await handle_response_url(res.getText());
      } catch (err) {
        console.error('Error leyendo QR en imagen:', err);
        setMessgeNotFound("No se pudo leer un código QR válido en la imagen.");
        setEnableButton(false);
        setEnableButtonNotFound(false);
      }
    };
  };

  return (
    <Container maxWidth="sm">
      <MODAL_TABLE open={false} message={''} message2={''} modalGeneral={false} modalT={modalT} />

      <ProcessPanel
        asOverlay
        open={proc.open}
        onClose={() => { }}
        title={proc.title}
        steps={updateSteps}
        progress={proc.progress}
      />


      <Stack spacing={1} sx={{ py: 1 }}>
        <input type="file" accept="image/*" ref={fileInputRef} onChange={onFileChange} style={{ display: 'none' }} />
        <Button variant="outlined" onClick={() => fileInputRef.current?.click()}>
          Subir imagen con QR
        </Button>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            overflow: 'hidden',
            minHeight: 300, // asegura que el área tenga altura aunque no haya imagen
            backgroundColor: '#fafafa',
          }}
        >
          {imagePreview ? (
            <Box
              component="img"
              src={imagePreview}
              alt="Vista previa"
              sx={{
                maxWidth: '250px',
                maxHeight: '250px',
                objectFit: 'contain',
              }}
            />
          ) : (
            <div style={{ textAlign: 'center', color: '#777' }}>
              Selecciona una imagen con el QR
            </div>
          )}
        </Box>

        <Stack direction="column" spacing={2}>
          {messgeNotFound !== "" && (

            <div style={{ color: "black", textAlign: "justify", backgroundColor: "#f9e79aff", padding: 7 }}>
              <p>{messgeNotFound}</p>
            </div>
          )}


          {type_Suplier && (
            <div style={{ color: "black", textAlign: "justify", backgroundColor: "#f9e79aff", padding: 7 }}>
              <p><b>Nota:</b> Actualmente, este socio está registrado como proveedor.
                ¿Desea actualizar el tipo a <b>cliente/proveedor</b>?</p>
              <button
                style={{ width: "100%", borderRadius: 5, backgroundColor: "#ab8919ff" }}
                onClick={handleBussinesPartner}
              >
                ACTUALIZAR TIPO DE SOCIO
              </button>
            </div>
          )}

          {update_type && (
            <div style={{ color: "black", textAlign: "justify", backgroundColor: "#f9e79aff", padding: 7 }}>
              Se ha actualizado correctamente el tipo de socio.
            </div>
          )}


          {enableButtonNotFound && (
            <div style={{ color: "black", textAlign: "justify", backgroundColor: "#f9e79aff", padding: 7 }}>
              No se encontró el socio de negocios. ¿Desea registrarlo?
            </div>
          )}

          {enableButtonNotFound && (
            <Button
              fullWidth size="large" variant="contained"
              sx={{ bgcolor: '#5B21B6', '&:hover': { bgcolor: '#4C1D95' } }}
              onClick={handle_redirect_page}
            >
              REGISTRAR NUEVO SOCIO
            </Button>
          )}

          {enableButton && (
            <Button
              fullWidth size="large" variant="contained"
              sx={{ bgcolor: '#059669', '&:hover': { bgcolor: '#047857' } }}
              onClick={handle_update_and_close}
            >
              ACTUALIZAR INFORMACIÓN DEL FORMULARIO
            </Button>
          )}
        </Stack>
      </Stack>
    </Container>
  );
};

export default CustomQRInvoiceImage;
